import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MPassService } from '../../services/mpass.service';

@Component({
  selector: 'app-logged-payment-card',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './logged-payment-card.component.html',
  styleUrls: ['./logged-payment-card.component.scss'],
})
export class LoggedPaymentCardComponent {
  private mpassService = inject(MPassService);
  public qrLocatorImage = computed(() => this.mpassService.qrLocatorImage());
}
